import React from 'react';

const Header = ({ payload }) => {
  const { filters, aito, setActiveFilter, activeFilter, header } = payload;

  const isActive = (tag) => activeFilter?.slug === tag.slug;

  return (
    <div className="c-reviews-listing__header">
      <h2>{header}</h2>

      <div className="c-reviews-listing__header__filters">
        <p className="o-text o-text--heavy">Filter our reviews by:</p>

        <div className="c-reviews-listing__filters">
          <span
            className={`c-reviews-listing__filters__single ${
              !activeFilter ? 'c-reviews-listing__filters__single--active' : ''
            }`}
            onClick={() => setActiveFilter(null)}
          >
            All Reviews
          </span>

          {filters.map((tag) => (
            <span
              className={`c-reviews-listing__filters__single ${
                isActive(tag)
                  ? 'c-reviews-listing__filters__single--active'
                  : ''
              }`}
              onClick={() => setActiveFilter(tag)}
              key={`tag-filter--${tag.slug}`}
            >
              {tag.display}
            </span>
          ))}
        </div>
      </div>

      {aito?.link && (
        <div className="c-reviews-listing__header__tp">
          <img
            src={aito.image}
            className="c-reviews-listing__header__tp__img"
          />

          <a
            href={aito?.link?.url}
            title={aito?.link?.title}
            className="o-btn o-btn--more o-btn--purple"
          >
            Read aito reviews
          </a>
        </div>
      )}
    </div>
  );
};

export default Header;
